import React, {Component} from 'react';
import {Row, Col, Breadcrumb, Spin} from 'antd';
import {Link} from 'react-router-dom';
import moment from 'moment';
import '../../css/players.css';
import {app, api} from "../../app";
import utils from "../../utils";

class PlayerRescueList extends Component {
    constructor(props) {
        const indexno = props.match.params.indexno;
        super(props);
        this.state = {
            indexno: indexno,
            rescueList: [],
            data_loading: true,
            currentYear: 1,
            year: moment().format("YYYY")
        };
        this.dataSource();
        app.setData('link_indexno', indexno);
    }

    /**
     * 数据源
     */
    dataSource() {
        const _this = this, indexno = this.state.indexno;
        app.post(api.ThisYearRescueList, {indexno}).then(({flag, data, msg}) => {
            if (flag === 1) {
                _this.setState({rescueList: utils.addArrayKey(data)});
            } else {
                app.alert("网络服务忙~", "error");
            }
            _this.setState({data_loading: false, year: moment().format("YYYY")});
        });
    }

    /**
     * 上年数据源
     */
    dataSource2() {
        const _this = this, indexno = this.state.indexno, year = parseInt(this.state.year) - 1;
        app.post(api.LastYearRescueList, {indexno}).then(({flag, data, msg}) => {
            if (flag === 1) {
                _this.setState({rescueList: utils.addArrayKey(data)});
            } else {
                app.alert("网络服务忙~", "error");
            }
            _this.setState({data_loading: false, year});
        });
    }

    /**
     * 年点击
     * @param year
     * @returns {boolean}
     */
    handleYearClick(year) {
        const currentYear = this.state.currentYear, loading = this.state.data_loading;
        if (year === currentYear || loading) {
            return false;
        }
        this.setState({data_loading: true});
        if (year === 1) {
            this.dataSource();
        } else if (year === 2) {
            this.dataSource2();
        }
        this.setState({currentYear: year});
    }

    /**
     * 跳转详情页
     * @param id
     */
    handleToDetail(id){
        if (id) {
            this.props.history.push('/player/rescuedetail/' + id);
        }
    }

    render() {
        const province = app.getData('link_province'), teamno = app.getData('link_teamno'), teamno1 = null,
            rescueList = this.state.rescueList || [], currentYear = this.state.currentYear, year = this.state.year,
            loading = this.state.data_loading;
        return (
            <div className="ranks_content">
                <div className="r_page_title">救援列表<span>Rescue list</span></div>
                <Breadcrumb separator=">" className="r_right_breadcrumb">
                    <Breadcrumb.Item><Link to="/">首页</Link></Breadcrumb.Item>
                    {province ? (<Breadcrumb.Item><Link to={"/ranks/pro/" + province}>队伍列表</Link></Breadcrumb.Item>) : ''}
                    {teamno1 ? (
                        <Breadcrumb.Item><Link to={"/ranks/detail/" + teamno1}>查看队伍</Link></Breadcrumb.Item>) : ''}
                    {teamno ? (
                        <Breadcrumb.Item><Link to={"/ranks/Players/" + teamno}>队员列表</Link></Breadcrumb.Item>) : ''}
                    <Breadcrumb.Item onClick={()=>{this.props.history.go(-1)}} className="pointer">个人页面</Breadcrumb.Item>
                    <Breadcrumb.Item>救援列表</Breadcrumb.Item>
                </Breadcrumb>
                <Row id="rc_all">
                    <Row className="top_title" type="flex" align="middle">
                        <Col span={8} className="link-lable">{currentYear === 1 ? <span onClick={() => {
                            this.handleYearClick(2)
                        }}>查看上年救援经历</span> : ''}</Col>
                        <Col span={8}>{loading ? '正在加载数据...' : `${year}年共救援${rescueList.length}次`}</Col>
                        <Col span={8} className="link-lable">{currentYear === 2 ? <span onClick={() => {
                            this.handleYearClick(1)
                        }}>查看下年救援经历</span> : ''}</Col>
                    </Row>
                    {
                        loading ? <Row type="flex" align="middle" justify="center" className="data_loading"><Spin
                                tip="正在加载中..."></Spin></Row>
                            : <Row className="bottom_content">
                                {
                                    rescueList.length > 0 ? rescueList.map((rescue, index) => {
                                        return (
                                            <Col span={24} className="bc_item" key={index + 1} onClick={()=>{this.handleToDetail(rescue.id);}}>
                                                <Row>
                                                    <Col span={18} className="bci_name">{rescue.rescuename}</Col>
                                                    <Col span={6} className="bci_date">{rescue.startdate}</Col>
                                                </Row>
                                            </Col>
                                        )
                                    }) : (<Row type="flex" justify="center" style={{width: "100%"}}>暂无记录</Row>)
                                }
                            </Row>
                    }
                </Row>
            </div>
        );
    }
}

export default PlayerRescueList;



// WEBPACK FOOTER //
// ./src/routes/playerInfo/PlayerRescueList.jsx